/* tslint:disable */
/* eslint-disable */
/**
 * SoudniSpory
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DruhPripaduVO } from '../model';
// @ts-ignore
import { FilterVO } from '../model';
// @ts-ignore
import { InstanceSouduVO } from '../model';
// @ts-ignore
import { OrgJednotkaVO } from '../model';
// @ts-ignore
import { ProtistranaVO } from '../model';
// @ts-ignore
import { RekapitulaceVO } from '../model';
// @ts-ignore
import { SoudVO } from '../model';
// @ts-ignore
import { SoudniSporDetailVO } from '../model';
// @ts-ignore
import { SoudniSporVO } from '../model';
// @ts-ignore
import { StavSporuVO } from '../model';
// @ts-ignore
import { TypKontrolaEnum } from '../model';
// @ts-ignore
import { TypSporuVO } from '../model';
// @ts-ignore
import { VysledekSporuVO } from '../model';
/**
 * SoudniSporyControllerApi - axios parameter creator
 * @export
 */
export const SoudniSporyControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} fulltext 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findProtistrana: async (fulltext: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fulltext' is not null or undefined
            assertParamExists('findProtistrana', 'fulltext', fulltext)
            const localVarPath = `/api/soudniSpory/findProtistrana`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fulltext !== undefined) {
                localVarQueryParameter['fulltext'] = fulltext;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDruhyPripadu: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/soudniSpory/druhyPripadu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstanceSoudu: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/soudniSpory/instanceSoudu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgJednotky: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/soudniSpory/orgJednotky`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} rok 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRekapitulace: async (rok: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rok' is not null or undefined
            assertParamExists('getRekapitulace', 'rok', rok)
            const localVarPath = `/api/soudniSpory/{rok}/rekapitulace`
                .replace(`{${"rok"}}`, encodeURIComponent(String(rok)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRekapitulaceRoky: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/soudniSpory/rekapitulaceRoky`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} idPripad ID dokumentu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoudniSporDetail: async (idPripad: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPripad' is not null or undefined
            assertParamExists('getSoudniSporDetail', 'idPripad', idPripad)
            const localVarPath = `/api/soudniSpory/{idPripad}/soudniSporDetail`
                .replace(`{${"idPripad"}}`, encodeURIComponent(String(idPripad)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí obraz souboru dokumentu z DMS
         * @param {number} idDokument ID případu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoudniSporPriloha: async (idDokument: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idDokument' is not null or undefined
            assertParamExists('getSoudniSporPriloha', 'idDokument', idDokument)
            const localVarPath = `/api/soudniSpory/{idDokument}/soudniSporPriloha`
                .replace(`{${"idDokument"}}`, encodeURIComponent(String(idDokument)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoudniSporyByIds: async (requestBody: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('getSoudniSporyByIds', 'requestBody', requestBody)
            const localVarPath = `/api/soudniSpory/soudniSporyByIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TypKontrolaEnum} typKontrola 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoudniSporyByKontrola: async (typKontrola: TypKontrolaEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'typKontrola' is not null or undefined
            assertParamExists('getSoudniSporyByKontrola', 'typKontrola', typKontrola)
            const localVarPath = `/api/soudniSpory/soudniSporyByKontrola`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (typKontrola !== undefined) {
                localVarQueryParameter['typKontrola'] = typKontrola;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} rok 
         * @param {number} idTypPripad 
         * @param {boolean} externi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoudniSporyByTyp: async (rok: number, idTypPripad: number, externi: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rok' is not null or undefined
            assertParamExists('getSoudniSporyByTyp', 'rok', rok)
            // verify required parameter 'idTypPripad' is not null or undefined
            assertParamExists('getSoudniSporyByTyp', 'idTypPripad', idTypPripad)
            // verify required parameter 'externi' is not null or undefined
            assertParamExists('getSoudniSporyByTyp', 'externi', externi)
            const localVarPath = `/api/soudniSpory/{rok}/soudniSporyByTyp`
                .replace(`{${"rok"}}`, encodeURIComponent(String(rok)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idTypPripad !== undefined) {
                localVarQueryParameter['idTypPripad'] = idTypPripad;
            }

            if (externi !== undefined) {
                localVarQueryParameter['externi'] = externi;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoudy: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/soudniSpory/soudy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStavySporu: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/soudniSpory/stavySporu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTypySporu: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/soudniSpory/typySporu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVysledkySporu: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/soudniSpory/vysledkySporu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FilterVO} [filterVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vyhledatSoudniSporyIds: async (filterVO?: FilterVO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/soudniSpory/vyhledatSoudniSporyIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filterVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SoudniSporyControllerApi - functional programming interface
 * @export
 */
export const SoudniSporyControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SoudniSporyControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} fulltext 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findProtistrana(fulltext: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProtistranaVO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findProtistrana(fulltext, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDruhyPripadu(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DruhPripaduVO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDruhyPripadu(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInstanceSoudu(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InstanceSouduVO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInstanceSoudu(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrgJednotky(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrgJednotkaVO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrgJednotky(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} rok 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRekapitulace(rok: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RekapitulaceVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRekapitulace(rok, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRekapitulaceRoky(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRekapitulaceRoky(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} idPripad ID dokumentu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSoudniSporDetail(idPripad: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SoudniSporDetailVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSoudniSporDetail(idPripad, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Vrátí obraz souboru dokumentu z DMS
         * @param {number} idDokument ID případu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSoudniSporPriloha(idDokument: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSoudniSporPriloha(idDokument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSoudniSporyByIds(requestBody: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SoudniSporVO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSoudniSporyByIds(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TypKontrolaEnum} typKontrola 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSoudniSporyByKontrola(typKontrola: TypKontrolaEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SoudniSporVO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSoudniSporyByKontrola(typKontrola, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} rok 
         * @param {number} idTypPripad 
         * @param {boolean} externi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSoudniSporyByTyp(rok: number, idTypPripad: number, externi: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SoudniSporVO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSoudniSporyByTyp(rok, idTypPripad, externi, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSoudy(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SoudVO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSoudy(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStavySporu(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StavSporuVO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStavySporu(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTypySporu(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TypSporuVO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTypySporu(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVysledkySporu(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VysledekSporuVO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVysledkySporu(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {FilterVO} [filterVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vyhledatSoudniSporyIds(filterVO?: FilterVO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vyhledatSoudniSporyIds(filterVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SoudniSporyControllerApi - factory interface
 * @export
 */
export const SoudniSporyControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SoudniSporyControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} fulltext 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findProtistrana(fulltext: string, options?: any): AxiosPromise<Array<ProtistranaVO>> {
            return localVarFp.findProtistrana(fulltext, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDruhyPripadu(options?: any): AxiosPromise<Array<DruhPripaduVO>> {
            return localVarFp.getDruhyPripadu(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstanceSoudu(options?: any): AxiosPromise<Array<InstanceSouduVO>> {
            return localVarFp.getInstanceSoudu(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgJednotky(options?: any): AxiosPromise<Array<OrgJednotkaVO>> {
            return localVarFp.getOrgJednotky(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} rok 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRekapitulace(rok: number, options?: any): AxiosPromise<RekapitulaceVO> {
            return localVarFp.getRekapitulace(rok, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRekapitulaceRoky(options?: any): AxiosPromise<Array<number>> {
            return localVarFp.getRekapitulaceRoky(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} idPripad ID dokumentu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoudniSporDetail(idPripad: number, options?: any): AxiosPromise<SoudniSporDetailVO> {
            return localVarFp.getSoudniSporDetail(idPripad, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí obraz souboru dokumentu z DMS
         * @param {number} idDokument ID případu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoudniSporPriloha(idDokument: number, options?: any): AxiosPromise<any> {
            return localVarFp.getSoudniSporPriloha(idDokument, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoudniSporyByIds(requestBody: Array<number>, options?: any): AxiosPromise<Array<SoudniSporVO>> {
            return localVarFp.getSoudniSporyByIds(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TypKontrolaEnum} typKontrola 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoudniSporyByKontrola(typKontrola: TypKontrolaEnum, options?: any): AxiosPromise<Array<SoudniSporVO>> {
            return localVarFp.getSoudniSporyByKontrola(typKontrola, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} rok 
         * @param {number} idTypPripad 
         * @param {boolean} externi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoudniSporyByTyp(rok: number, idTypPripad: number, externi: boolean, options?: any): AxiosPromise<Array<SoudniSporVO>> {
            return localVarFp.getSoudniSporyByTyp(rok, idTypPripad, externi, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoudy(options?: any): AxiosPromise<Array<SoudVO>> {
            return localVarFp.getSoudy(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStavySporu(options?: any): AxiosPromise<Array<StavSporuVO>> {
            return localVarFp.getStavySporu(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTypySporu(options?: any): AxiosPromise<Array<TypSporuVO>> {
            return localVarFp.getTypySporu(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVysledkySporu(options?: any): AxiosPromise<Array<VysledekSporuVO>> {
            return localVarFp.getVysledkySporu(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FilterVO} [filterVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vyhledatSoudniSporyIds(filterVO?: FilterVO, options?: any): AxiosPromise<Array<number>> {
            return localVarFp.vyhledatSoudniSporyIds(filterVO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SoudniSporyControllerApi - interface
 * @export
 * @interface SoudniSporyControllerApi
 */
export interface SoudniSporyControllerApiInterface {
    /**
     * 
     * @param {string} fulltext 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApiInterface
     */
    findProtistrana(fulltext: string, options?: AxiosRequestConfig): AxiosPromise<Array<ProtistranaVO>>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApiInterface
     */
    getDruhyPripadu(options?: AxiosRequestConfig): AxiosPromise<Array<DruhPripaduVO>>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApiInterface
     */
    getInstanceSoudu(options?: AxiosRequestConfig): AxiosPromise<Array<InstanceSouduVO>>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApiInterface
     */
    getOrgJednotky(options?: AxiosRequestConfig): AxiosPromise<Array<OrgJednotkaVO>>;

    /**
     * 
     * @param {number} rok 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApiInterface
     */
    getRekapitulace(rok: number, options?: AxiosRequestConfig): AxiosPromise<RekapitulaceVO>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApiInterface
     */
    getRekapitulaceRoky(options?: AxiosRequestConfig): AxiosPromise<Array<number>>;

    /**
     * 
     * @param {number} idPripad ID dokumentu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApiInterface
     */
    getSoudniSporDetail(idPripad: number, options?: AxiosRequestConfig): AxiosPromise<SoudniSporDetailVO>;

    /**
     * Vrátí obraz souboru dokumentu z DMS
     * @param {number} idDokument ID případu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApiInterface
     */
    getSoudniSporPriloha(idDokument: number, options?: AxiosRequestConfig): AxiosPromise<any>;

    /**
     * 
     * @param {Array<number>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApiInterface
     */
    getSoudniSporyByIds(requestBody: Array<number>, options?: AxiosRequestConfig): AxiosPromise<Array<SoudniSporVO>>;

    /**
     * 
     * @param {TypKontrolaEnum} typKontrola 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApiInterface
     */
    getSoudniSporyByKontrola(typKontrola: TypKontrolaEnum, options?: AxiosRequestConfig): AxiosPromise<Array<SoudniSporVO>>;

    /**
     * 
     * @param {number} rok 
     * @param {number} idTypPripad 
     * @param {boolean} externi 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApiInterface
     */
    getSoudniSporyByTyp(rok: number, idTypPripad: number, externi: boolean, options?: AxiosRequestConfig): AxiosPromise<Array<SoudniSporVO>>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApiInterface
     */
    getSoudy(options?: AxiosRequestConfig): AxiosPromise<Array<SoudVO>>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApiInterface
     */
    getStavySporu(options?: AxiosRequestConfig): AxiosPromise<Array<StavSporuVO>>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApiInterface
     */
    getTypySporu(options?: AxiosRequestConfig): AxiosPromise<Array<TypSporuVO>>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApiInterface
     */
    getVysledkySporu(options?: AxiosRequestConfig): AxiosPromise<Array<VysledekSporuVO>>;

    /**
     * 
     * @param {FilterVO} [filterVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApiInterface
     */
    vyhledatSoudniSporyIds(filterVO?: FilterVO, options?: AxiosRequestConfig): AxiosPromise<Array<number>>;

}

/**
 * SoudniSporyControllerApi - object-oriented interface
 * @export
 * @class SoudniSporyControllerApi
 * @extends {BaseAPI}
 */
export class SoudniSporyControllerApi extends BaseAPI implements SoudniSporyControllerApiInterface {
    /**
     * 
     * @param {string} fulltext 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApi
     */
    public findProtistrana(fulltext: string, options?: AxiosRequestConfig) {
        return SoudniSporyControllerApiFp(this.configuration).findProtistrana(fulltext, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApi
     */
    public getDruhyPripadu(options?: AxiosRequestConfig) {
        return SoudniSporyControllerApiFp(this.configuration).getDruhyPripadu(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApi
     */
    public getInstanceSoudu(options?: AxiosRequestConfig) {
        return SoudniSporyControllerApiFp(this.configuration).getInstanceSoudu(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApi
     */
    public getOrgJednotky(options?: AxiosRequestConfig) {
        return SoudniSporyControllerApiFp(this.configuration).getOrgJednotky(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} rok 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApi
     */
    public getRekapitulace(rok: number, options?: AxiosRequestConfig) {
        return SoudniSporyControllerApiFp(this.configuration).getRekapitulace(rok, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApi
     */
    public getRekapitulaceRoky(options?: AxiosRequestConfig) {
        return SoudniSporyControllerApiFp(this.configuration).getRekapitulaceRoky(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} idPripad ID dokumentu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApi
     */
    public getSoudniSporDetail(idPripad: number, options?: AxiosRequestConfig) {
        return SoudniSporyControllerApiFp(this.configuration).getSoudniSporDetail(idPripad, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí obraz souboru dokumentu z DMS
     * @param {number} idDokument ID případu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApi
     */
    public getSoudniSporPriloha(idDokument: number, options?: AxiosRequestConfig) {
        return SoudniSporyControllerApiFp(this.configuration).getSoudniSporPriloha(idDokument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApi
     */
    public getSoudniSporyByIds(requestBody: Array<number>, options?: AxiosRequestConfig) {
        return SoudniSporyControllerApiFp(this.configuration).getSoudniSporyByIds(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TypKontrolaEnum} typKontrola 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApi
     */
    public getSoudniSporyByKontrola(typKontrola: TypKontrolaEnum, options?: AxiosRequestConfig) {
        return SoudniSporyControllerApiFp(this.configuration).getSoudniSporyByKontrola(typKontrola, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} rok 
     * @param {number} idTypPripad 
     * @param {boolean} externi 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApi
     */
    public getSoudniSporyByTyp(rok: number, idTypPripad: number, externi: boolean, options?: AxiosRequestConfig) {
        return SoudniSporyControllerApiFp(this.configuration).getSoudniSporyByTyp(rok, idTypPripad, externi, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApi
     */
    public getSoudy(options?: AxiosRequestConfig) {
        return SoudniSporyControllerApiFp(this.configuration).getSoudy(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApi
     */
    public getStavySporu(options?: AxiosRequestConfig) {
        return SoudniSporyControllerApiFp(this.configuration).getStavySporu(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApi
     */
    public getTypySporu(options?: AxiosRequestConfig) {
        return SoudniSporyControllerApiFp(this.configuration).getTypySporu(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApi
     */
    public getVysledkySporu(options?: AxiosRequestConfig) {
        return SoudniSporyControllerApiFp(this.configuration).getVysledkySporu(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FilterVO} [filterVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoudniSporyControllerApi
     */
    public vyhledatSoudniSporyIds(filterVO?: FilterVO, options?: AxiosRequestConfig) {
        return SoudniSporyControllerApiFp(this.configuration).vyhledatSoudniSporyIds(filterVO, options).then((request) => request(this.axios, this.basePath));
    }
}
